import { ValueOf } from '../utilities/types';

const providerNames = {
  ROARING: 'Roaring',
  ROARING_SANDBOX: 'RoaringSandbox',
  TRAPETS: 'Trapets',
  TRAPETS_SANDBOX: 'TrapetsSandbox',
  BILVISON: 'Bilvison',
  BILVISON_SANDBOX: 'BilvisonSandbox',
  CREDITSAFE: 'Creditsafe',
  CREDITSAFE_SANDBOX: 'CreditsafeSandbox',
  CREDITSAFE_CONNECT: 'CreditsafeConnect',
  CREDITSAFE_CONNECT_SANDBOX: 'CreditsafeConnectSandbox',
  CREDITSAFE_SPAR: 'CreditsafeSpar',
  VERIFIERA: 'Verifiera',
  VERIFIERA_SANDBOX: 'VerifieraSandbox',
  SPAR: 'Spar',
  SPAR_SANDBOX: 'SparSandbox',
  MOODYS_GRID: 'MoodysGrid',
  MOODYS_ORBIS: 'MoodysOrbis',
  FILE_BASED: 'FileBased',
  // Should they by providers?
  MANUAL_INPUT: 'ManualInput',
  FORM: 'Form',
} as const;

export type ProviderNames = ValueOf<typeof providerNames>;

export default providerNames;
